import { atom } from 'jotai'

export const aIsFormLocked = atom<boolean>(false)
